import React, { Fragment, useState } from "react";
import { withStyles } from "@mui/styles";
import { compose } from "recompose";
import "views/Pma/PmaEditor/TableQuadrants/table-quadrants-editor.scss";
import "./local-events-modal.scss";
import { withSnackbar } from "notistack";
import LocalEventsOrganizations from "./LocalEventsOrganizations";

const LocalEventsEditorModal = (props) => {
  const [validationErrors, setValidationErrors] = useState({
    title: false,
    text: false,
  });
  const {
    handleInputChange,
    editQuadrantFormData,
    onCloseFn,
    onEditFormSubmit,
    selectedQuadrantNumber,
    titleEdit,
    maxMainTitleLength,
    maxMainSubtitleLength,
    savingMessageShowing,
    selectEventText,
    currentArea,
    agentData,
    altAgentData,
    fromEditor,
  } = props;
  const modalContainerClassName = `edit-local-events-container${
    fromEditor ? " from-editor-mode" : ""
  }`;
  const transformInput = (str) => {
    let capital = str.charAt(0).toUpperCase() + str.slice(1);
    return capital;
  };
  if (titleEdit) {
    const { eventAreaSubTitle, eventAreaTitle } = editQuadrantFormData;
    let overMaxMainTitleLength =
      eventAreaTitle &&
      eventAreaTitle.length &&
      eventAreaTitle.length >= maxMainTitleLength;
    let overMaxMainSubtitleLength =
      eventAreaSubTitle &&
      eventAreaSubTitle.length &&
      eventAreaSubTitle.length >= maxMainSubtitleLength;
    return (
      <Fragment>
        <div className={modalContainerClassName}>
          <div className="edit-local-events-form new-props">
            <div className="edit-local-events-form-title-container">
              <p className="edit-local-events-form-title-text">
                You Can Make Changes to the Header Here
              </p>
            </div>
            <div className="edit-local-events-form-body">
              <div className="edit-form-body-col">
                <div className="edit-form-thead">
                  <div>
                    <p>Header</p>
                  </div>
                </div>
                <div className="edit-form-input main-title-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`main-title`}
                      name={`eventAreaTitle`}
                      className="title-input"
                      value={eventAreaTitle || ""}
                      onChange={handleInputChange}
                      placeholder={eventAreaTitle}
                      maxLength={maxMainTitleLength}
                    ></input>
                    <label
                      htmlFor="quadrantsTitle"
                      className={
                        overMaxMainTitleLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {eventAreaTitle && eventAreaTitle.length
                        ? eventAreaTitle.length
                        : "0"}
                      /{maxMainTitleLength}
                    </label>
                  </div>
                </div>
              </div>

              {/* <div className="edit-form-body-col">
                <div className="edit-form-thead subtitle-thead">
                  <div>
                    <p>Subheader</p>
                  </div>
                </div>
                <div className="edit-form-input subtitle-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`eventAreaSubTitle`}
                      name={`eventAreaSubTitle`}
                      className="title-input"
                      value={transformInput(eventAreaSubTitle) || ""}
                      onChange={handleInputChange}
                      placeholder={eventAreaSubTitle}
                      maxLength={maxMainSubtitleLength}
                    ></input>
                    <label
                      htmlFor="eventAreaSubTitle"
                      className={
                        overMaxMainSubtitleLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {eventAreaSubTitle && eventAreaSubTitle.length
                        ? eventAreaSubTitle.length
                        : "0"}
                      /{maxMainSubtitleLength}
                    </label>
                  </div>
                </div>
              </div>*/}
            </div>
          </div>

          <div className="edit-form-button-container">
            <div className="button-col">
              <div
                className="edit-form-cancel-button"
                onClick={() => onCloseFn(selectedQuadrantNumber)}
              >
                <p>Cancel</p>
              </div>
            </div>
            <div className="button-col">
              <div
                className="edit-form-submit-button"
                onClick={onEditFormSubmit}
              >
                <p>Save</p>
              </div>
            </div>
          </div>
          {props.duplicateError && (
            <div className="duplicate-error-message">
              {props.duplicateError}
            </div>
          )}
          {savingMessageShowing && (
            <div className="saving-message">Your work has been saved!</div>
          )}
        </div>
      </Fragment>
    );
  } else {
    let quadrantTitle =
      editQuadrantFormData[`eventHeading${selectedQuadrantNumber}`];
    let quadrantText =
      editQuadrantFormData[`eventText${selectedQuadrantNumber}`];
    let quadrantWebsiteURL =
      editQuadrantFormData[`eventFooter${selectedQuadrantNumber}`];
    let maxQuadrantTextLength = 85;
    let overMaxQuadrantTextLength =
      quadrantText &&
      quadrantText.length &&
      quadrantText.length >= maxQuadrantTextLength;
    let maxQuadrantTitleLength = 45;
    let overMaxQuadrantTitleLength =
      quadrantTitle &&
      quadrantTitle.length &&
      quadrantTitle.length >= maxQuadrantTitleLength;
    let maxWebsiteURLTextLength = 70;
    let overMaxWebsiteURLLength =
      quadrantWebsiteURL &&
      quadrantWebsiteURL.length &&
      quadrantWebsiteURL.length >= maxWebsiteURLTextLength;
    let blankOrganization = {
      localEventID: "blank",
      localEventHeader: "",
      localEventText: "",
      localEventFooter: "",
    };
    const handleSaveClick = () => {
      const hasValidationErrors = {};
      if (!quadrantTitle || quadrantTitle.length <= 4) {
        hasValidationErrors.title = true;
      }
      if (!quadrantText || quadrantText.length <= 4) {
        hasValidationErrors.text = true;
      }
      setValidationErrors(hasValidationErrors);
      if (Object.keys(hasValidationErrors).length === 0) {
        onEditFormSubmit();
      }
    };
    return (
      <Fragment>
        <div className={modalContainerClassName}>
          <div className="edit-local-events-form new-props">
            <div className="edit-local-events-form-title-container">
              <p className="edit-local-events-form-title-text">
                You can erase this event and enter your own favorite
              </p>
            </div>
            <div className="edit-local-events-erase-btn-container">
              <div
                className="edit-local-events-erase-btn"
                onClick={() =>
                  selectEventText(blankOrganization, selectedQuadrantNumber)
                }
              >
                <p>CLICK HERE TO ADD YOUR OWN CUSTOM EVENT</p>
              </div>
            </div>
            <div className="edit-local-events-form-body row-body">
              <div className="edit-form-body-col">
                <div className="edit-form-thead">
                  <div>
                    <p>Event Name</p>
                  </div>
                </div>
                <div className="edit-form-input">
                  <div className="address-input-col">
                    <input
                      type="text"
                      id={`eventHeading${selectedQuadrantNumber}`}
                      name={`eventHeading${selectedQuadrantNumber}`}
                      className="title-input"
                      value={quadrantTitle || ""}
                      onChange={handleInputChange}
                      placeholder={quadrantTitle}
                      maxLength={maxQuadrantTitleLength}
                    ></input>
                    <label
                      htmlFor={`eventHeading${selectedQuadrantNumber}`}
                      className={
                        overMaxQuadrantTitleLength
                          ? "character-count-error"
                          : ""
                      }
                    >
                      Character count:{" "}
                      {quadrantTitle && quadrantTitle.length
                        ? quadrantTitle.length
                        : "0"}
                      /{maxQuadrantTitleLength}
                    </label>
                    {validationErrors.title && (
                      <div
                        className="validation-error"
                        style={{ color: "red", marginTop: "5px" }}
                      >
                        Must have 5 characters or more before saving
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="textarea-column">
                <div className="edit-form-body-col">
                  <div className="edit-form-thead">
                    <div>
                      <p>Event Description</p>
                    </div>
                  </div>
                  <div className="edit-form-input">
                    <div className="address-input-col">
                      <textarea
                        placeholder={quadrantText}
                        onChange={handleInputChange}
                        name={`eventText${selectedQuadrantNumber}`}
                        value={quadrantText || ""}
                        className="quadrant-textarea"
                        maxLength={maxQuadrantTextLength}
                      ></textarea>

                      <label
                        htmlFor={`eventText${selectedQuadrantNumber}`}
                        className={
                          overMaxQuadrantTextLength
                            ? "character-count-error"
                            : ""
                        }
                      >
                        Character count:{" "}
                        {quadrantText && quadrantText.length
                          ? quadrantText.length
                          : "0"}
                        /{maxQuadrantTextLength}
                      </label>
                      {validationErrors.text && (
                        <div
                          className="validation-error"
                          style={{ color: "red", marginTop: "5px" }}
                        >
                          Must have 5 characters or more before saving
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="edit-form-body-col">
                  <div className="edit-form-thead">
                    <div>
                      <p>Location and Dates</p>
                    </div>
                  </div>
                  <div className="edit-form-input">
                    <div className="address-input-col">
                      <textarea
                        placeholder={quadrantWebsiteURL}
                        onChange={handleInputChange}
                        name={`eventFooter${selectedQuadrantNumber}`}
                        value={quadrantWebsiteURL || ""}
                        className="websiteURL-textarea"
                        maxLength={maxWebsiteURLTextLength}
                      ></textarea>

                      <label
                        htmlFor={`eventFooter${selectedQuadrantNumber}`}
                        className={
                          overMaxWebsiteURLLength ? "character-count-error" : ""
                        }
                      >
                        Character count:{" "}
                        {quadrantWebsiteURL && quadrantWebsiteURL.length
                          ? quadrantWebsiteURL.length
                          : "0"}
                        /{maxWebsiteURLTextLength}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="edit-form-button-container">
            <div className="button-col">
              <div
                className="edit-form-cancel-button"
                onClick={() => onCloseFn(selectedQuadrantNumber)}
              >
                <p>Cancel</p>
              </div>
              {/*<div className="restore-default" onClick={handleRestoreDefault}>
                <p>Restore Default</p>
              </div>*/}
            </div>
            <div className="button-col">
              <div
                className="edit-form-submit-button"
                onClick={handleSaveClick}
              >
                <p>Save</p>
              </div>
            </div>
          </div>
          {props.duplicateError && (
            <div className="duplicate-error-message">
              {props.duplicateError}
            </div>
          )}
          {savingMessageShowing && (
            <div className="saving-message">Your work has been saved!</div>
          )}
          <LocalEventsOrganizations
            selectEventText={selectEventText}
            selectedQuadrantNumber={selectedQuadrantNumber}
            currentArea={currentArea}
            agentData={agentData}
            altAgentData={altAgentData}
            editQuadrantFormData={editQuadrantFormData}
          />
        </div>
        {/*</Dialog>*/}
      </Fragment>
    );
  }
};

export default compose(withSnackbar)(LocalEventsEditorModal);
